import * as Yup from 'yup';

const jobAlertModalContentSchema = Yup.object({
  email: Yup.string()
    .required('Wir benötigen deine E-Mail-Adresse.')
    .email('Die E-Mail-Adresse ist leider nicht korrekt.'),
  timeType: Yup.array()
    .of(Yup.string())
    .min(1, 'Bitte wähle mindestens eine Arbeitszeit aus'),
  categories: Yup.array()
    .of(Yup.string())
    .min(1, 'Bitte wähle mindestens eine Kategorie aus'),
});

export default jobAlertModalContentSchema;
